import reducer from "./blogSlice";

export default reducer;
